module.exports = __webpack_public_path__ + "static/media/DAZN.1d9523ce.png";